module.exports = __webpack_public_path__ + "static/media/hist3.a9607eb6.jpg";